import * as operatorsApi from '@/network/api/operators.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'
import * as accountsApi from '@/network/api/accounts.api.js'

/** request Operators
@return { promise } - Operators request
*/
export const requestOperators = async context => {
    const res = await operatorsApi.getOperatorsList()

    if (res) { context.commit('SAVE_OPERATORS', res.data.data.list) }
    return res
}

/** request Operator Detail
@return { promise } - Operator detail request
*/
export const requestOperatorDetail = async (context, payload) => {
    const res = await operatorsApi.getOperatorDetail(payload)

    return res.data.data
}

/** request operations types
@return { promise } - operations types request
*/
export const requestOperationsTypes = async context => {
    if (context.state.operationsTypesList.length) return

    const res = await operationsApi.getOperationsTypesList({
        onlyListed: true,
        isSigned: true
    })

    if (res) { context.commit('SAVE_OPERATIONS_TYPES', res.data.data) }

    return res
}

/** request accounts
@return { promise } - accounts request
*/
export const requestAccounts = async context => {
    if (context.state.accounts.length) return

    const res = await accountsApi.accounts({ payload: '', params: '' })

    if (res) { context.commit('SAVE_ACCOUNTS', res.data.data) }

    return res
}

/** request profiles
@return { promise } - profiles request
*/
export const requestProfiles = async context => {
    if (context.state.profiles.length) return

    const res = await operatorsApi.getOperatorsProfilesList()

    if (res) { context.commit('SAVE_PROFILES', res.data.data.operatorProfileViewList) }

    return res
}

/** request plafonds and limits
@return { promise } - plafonds and limits request
*/
export const requestPlafondsAndLimits = async context => {
    if (context.state.plafondsAndLimits.length) return

    const res = await accountsApi.requestAccountsPlafondsandlimits()

    if (res) { context.commit('SAVE_PLAFONDS_LIMITS', res.data.data.accountWithOperationTypeListWithPlafondsAndTransactionLimits) }

    return res
}

/** reset password
@return { promise } - reset password request
*/
export const resetPassword = async (context, payload) => {
    const res = await operatorsApi.resetOperatorPassword(payload)

    return res
}

/** deletes operator
@return { promise } - delete operator request
*/
export const deleteOperator = async (context, payload) => {
    const res = await operatorsApi.deleteOperator(payload)

    return res.data
}

/** creates operator
@return { promise } - create operator request
*/
export const createOperator = async (context, payload) => {
    const res = await operatorsApi.createOperator(payload)

    return res.data
}

/** edits/blocks/unblocks operator
@return { promise } - edits, blocks or unblocks operator
*/
export const editOperator = async (context, payload) => {
    const res = await operatorsApi.editOperator(payload)

    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
